import { GET, POSTForm, GETBlob } from '..'

export const getCompaniesDocumentType = () => {
  return GET('/api/document-type/companies')
}

export const getUsersDocumentType = () => {
  return GET('/api/document-type/users')
}

export const downloadProtocoloFile = () => {
  return GETBlob('/api/document-type/document-protocolo')
}

export const getCuntries = () => {
  return GET('/api/location/countries')
}

export const getRegions = (countryId) => {
  return GET(`/api/location/${countryId}/regions`)
}

export const getCities = (regionId) => {
  return GET(`/api/location/${regionId}/cities`)
}

export const getRoles = () => {
  return GET('/api/company-role')
}

export const getTransformationsTypes = () => {
  return GET('/api/transformation-type')
}

export const getMaterialTypeProcessed = () => {
  return GET('/api/type-material-processed')
}

export const getOtherMaterialTypeProcessed = () => {
  return GET('/api/type-material-processed-other')
}

export const getEnvironmentalAutorization = () => {
  return GET('/api/environmental-authorization')
}

export const registerUser = (data) => {
  return POSTForm('/api/user', data)
}

export const registerUserActor = (data) => {
  return POSTForm('/api/user/actor', data)
}

export const registerUpdateUser = (data) => {
  return POSTForm('/api/user/update', data)
}


export const getTransformer = (callerCompanyId) => {
  const qs = callerCompanyId ? `?companyId=${callerCompanyId}` : ''
  return GET(`/api/transformers${qs}`)
}

export const getTransformersByManager = (tokenId, callerCompanyId) => {
  const qs = callerCompanyId ? `?companyId=${callerCompanyId}` : ''
  return GET(`/api/transformers/transformers-by-manager/${tokenId}${qs}`)
}

export const getManager = () => {
  return GET('/api/user/all-companies-info')
}

export const getManagers = () => {
  return GET('/api/user/all-companies-managers-info')
}



export const getEquivalentCollectionMechanisms = () => {
  return GET('/api/equivalent-collection-mechanisms')
}

export const registerUserCreateVerifier = (data) => {
  return POSTForm('/api/user/create-verifier', data)
}



